// import {
//     match1, match2, match3, match4, match5, match7,
//     match8, match9, match10, match11
// } from "../../constants/regex";

const phpErrorHandler = (errors) => {
    console.log(errors)
    // const error_info = errors[2];
};

export { phpErrorHandler };